import i18n from '~/localization/i18n';
import { extractErrorResponse } from './authErrorMapper';

export const uniConnectionErrorMapper = error => {
    const errors = extractErrorResponse(error) || [];
    const err = errors.length > 0 ? errors[0] : {};

    if (err.code === 'EmailNotAvailable') {
        return i18n.t('errors.uniConnErrorText.emailNotAvailable');
    } else if (err.code === 'InvalidEmailDomain') {
        return i18n.t('errors.uniConnErrorText.invalidEmailDomain');
    } else if (err.code === 'ExistingConnection') {
        return i18n.t('errors.uniConnErrorText.existingConnection');
    }
    return i18n.t('errors.uniConnErrorText.default');
};
